export default "__VITE_PUBLIC_ASSET__a2e3916d__"